// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import jquery from 'jquery'
//window.jQuery = jquery
//window.$ = jquery
import "./modules/future_payments"


function pageReady() {
  jquery(".dropdown").on("mouseenter",
    function () {
      this.classList.add("show");
    }
  );

  jquery(".dropdown").on("mouseleave",
    function () {
      this.classList.remove("show");
    }
  );

  jquery(".nav-item").on("click",function(e){
    if(e.target.href){
      window.location.href  = e.target.href;  
    }
  });
}

// Turbo-Links Navigation handling
jquery(document).on("page:load", pageReady);
jquery(document).on("turbo:load", pageReady);

jquery(function () {
  pageReady();
})
